









export default {
  name: "NotFound",
};
